// @flow
import React, { type Element } from 'react';
import AdminEdit from './AdminEdit';

const AdminList = (): Element<*> => <AdminEdit />;

export default AdminList;